import React  from 'react'
import { numberFormat } from 'estimate_list/libs/util'
import Thumb from './thumb'
import Alink from 'estimate_list/libs/alink'

const Item = ({ itemData }) => {
    const link = `${process.env.REACT_APP_SHOPPING_URL}/detail/${itemData.item_id}`
    return (
        <li>
            <Alink href={link}>
                <div className="thumb">
                    <Thumb src={itemData.img_url} />
                </div>
                {/* 메이커명 추가 */}
                <div className="title">{itemData.maker_name} {itemData.item_name}</div>
                <div className="price">
                    {itemData.price_low === null || itemData.price_low === 0 || itemData.market.length === 0 ? (
                        <strong>가격비교 예정</strong>
                    ) : (
                        <>
                            <strong>
                                {numberFormat(itemData.price_low)}
                            </strong>
                            원
                        </>
                    )}
                </div>
            </Alink>
        </li>
    )
}

export default Item



// WEBPACK FOOTER //
// ./src/estimate_list/components/stdpc/item.js